module.exports = __webpack_public_path__ + "img/logo.11b1b07e.svg";